<template>
  <el-select
    v-model="checkListCopy"
    clearable
    multiple
    filterable
    :placeholder="placeholder"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-option
      v-for="item in optionList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
export default {
  name: 'MultipleSelect',

  model: {
    prop: 'checkList',
    event: 'check'
  },

  props: {
    checkList: {
      type: [String, Array, Object],
      default: () => {
        return []
      }
    },

    /**
     * 是否添加全部
     */
    isNeedAll: {
      type: Boolean,
      default: true
    },

    options: {
      type: Array,
      default: () => {
        return []
      }
    },

    placeholder: {
      type: String,
      default: '请选择'
    }
  },

  data() {
    return {}
  },

  computed: {
    optionList() {
      if (this.isNeedAll && this.options.length) {
        return [{ label: '全部', value: 'all' }].concat(this.options || [])
      } else {
        return this.options || []
      }
    },

    checkListCopy: {
      get() {
        return this.checkList
      },

      set(newValue) {
        if (this.isNeedAll) {
          const lastItem = newValue[newValue.length - 1]

          let result = []
          if (lastItem === 'all') {
            result = ['all']
          } else {
            const tempArr = newValue.filter(item => item !== 'all')
            // const isFlag = this.options.every(item => {
            //   return tempArr
            //     .map(v => v.toString())
            //     .includes(item.value.toString())
            // })

            // result = isFlag ? ['all'] : tempArr
            result = tempArr
          }

          // console.log('set-value', result)
          this.$emit('check', result)
        } else {
          // console.log('set-value', newValue)
          this.$emit('check', newValue)
        }
      }
    }
  },

  methods: {}
}
</script>

<style scoped lang="scss"></style>
